import { TagRecord, TagRecordWithCount } from "@elixir/types";
import React from "react";
import { ListOfTagsUi, PopoverContainerUi } from "ui";
import CreateATagComponent from "./create-a-tag";

export type TTagsPopupProps = {
  tags: Array<TagRecordWithCount>;
  onClose: () => void;
  selectedTags: Array<TagRecord["tag_id"]>;
  onTagSelect: (selectedTagId: TagRecord["tag_id"]) => void;
  defaultState?: "LIST" | "CREATE";
};

const TagsPopup = ({
  tags,
  onClose,
  selectedTags,
  onTagSelect,
  defaultState = "LIST",
}: TTagsPopupProps) => {
  const [tagsCurrState, setTagsCurrState] = React.useState<"LIST" | "CREATE">(
    () => defaultState
  );

  // React.useEffect(() => {
  //   if (tags.length === 0) {
  // setTagsCurrState("CREATE");
  //   }
  // }, [tags.length]);

  const handleOnCreateTagClick = () => {
    setTagsCurrState("CREATE");
  };

  const handleGoBackOnCreateTag = () => {
    setTagsCurrState("LIST");
  };

  const handleCreateTagSelectAfterSelection = (tagId: TagRecord["tag_id"]) => {
    onTagSelect(tagId);
    onClose();
  };

  return (
    <PopoverContainerUi className="dr-max-h-502 overflow-y-auto dr-max-w-408 dr-w-408">
      {tagsCurrState === "LIST" ? (
        <ListOfTagsUi
          tags={tags}
          onClose={onClose}
          selectedTags={selectedTags}
          onTagClick={onTagSelect}
          onCreateTagClick={handleOnCreateTagClick}
        />
      ) : (
        <CreateATagComponent
          handleTagSelect={handleCreateTagSelectAfterSelection}
          onClose={onClose}
          onGoBackClick={handleGoBackOnCreateTag}
        />
      )}
    </PopoverContainerUi>
  );
};

export default TagsPopup;
